// Reactインポート
import React, { useState } from "react";
import { Link } from "react-router-dom";

// ヘッダースタイル
import "../css/Nav.scss";

// ロゴイメージ
import logo from "../img/top/logo.png";

function Nav() {
  const [navbarOpen, setNavbarOpen] = useState(false);

  const handleToggle = () => {
    setNavbarOpen(!navbarOpen);
  };

  return (
    <nav id="navigator">
      <ul className="navigator-list">
        <Link to="/">
          <li>
            <div className="nav-item-en">TOP</div>
            <div className="nav-item-jp">トップ</div>
          </li>
        </Link>
        <Link to="/about">
          <li>
            <div className="nav-item-en">ABOUT</div>
            <div className="nav-item-jp">事業概要</div>
          </li>
        </Link>
        {/* <Link to="/services">
          <a href="/">
            <li>
              <div className="nav-item-en">SERVICES</div>
              <div className="nav-item-jp">サービス</div>
            </li>
          </a>
        </Link> */}
        <Link to="/works">
          <a href="/">
            <li>
              <div className="nav-item-en">WORKS</div>
              <div className="nav-item-jp">制作事例</div>
            </li>
          </a>
        </Link>
        <Link to="/portfolio">
          <a href="/">
            <li>
              <div className="nav-item-en">PORTFOLIO</div>
              <div className="nav-item-jp">ポートフォリオ</div>
            </li>
          </a>
        </Link>
        <Link to="/packages">
          <a href="/">
            <li>
              <div className="nav-item-en">PACKAGES</div>
              <div className="nav-item-jp">パッケージ</div>
            </li>
          </a>
        </Link>
        <Link to="/contactform">
          <a href="/">
            <li>
              <div className="nav-item-en">CONTACT</div>
              <div className="nav-item-jp">無料相談</div>
            </li>
          </a>
        </Link>
      </ul>

      <div className="background">
        <div className="navigator-sp">
          <Link to="/">
            <div className="navigator-img1">
              <img src={logo} alt="" />
            </div>
          </Link>
        </div>

        {/* spOnly,1366_Width */}
        <div className="navBar">
          <div
            className={`openbtn4 ${navbarOpen ? " active" : ""}`}
            onClick={handleToggle}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className={`menuNav ${navbarOpen ? " showMenu" : ""}`}>
            <Link to="/" onClick={handleToggle}>
              <li>
                <div className="nav-item-en">TOP</div>
                <div className="nav-item-jp">トップ</div>
              </li>
            </Link>
            <Link to="/about" onClick={handleToggle}>
              <li>
                <div className="nav-item-en">ABOUT</div>
                <div className="nav-item-jp">事業概要</div>
              </li>
            </Link>
            {/* <Link to="/services">
              <li>
                <div className="nav-item-en">SERVICES</div>
                <div className="nav-item-jp">サービス</div>
              </li>
            </Link> */}
            <Link to="/works" onClick={handleToggle}>
              <li>
                <div className="nav-item-en">WORKS</div>
                <div className="nav-item-jp">制作事例</div>
              </li>
            </Link>
            <Link to="/portfolio" onClick={handleToggle}>
              <li>
                <div className="nav-item-en">PORTFOLIO</div>
                <div className="nav-item-jp">ポートフォリオ</div>
              </li>
            </Link>
            <Link to="/packages" onClick={handleToggle}>
              <li>
                <div className="nav-item-en">PACKAGES</div>
                <div className="nav-item-jp">パッケージ</div>
              </li>
            </Link>
            <Link to="/contactform" onClick={handleToggle}>
              <li>
                <div className="nav-item-en">CONTACT</div>
                <div className="nav-item-jp">無料相談</div>
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
